import React, { useState, useEffect, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { Table, Button, FloatingLabel, Form } from 'react-bootstrap';
import 'react-toastify/dist/ReactToastify.css';
import Factory from '../../../components/factory';
import { get } from '../../../services/apiController';
import { GrDocumentExcel } from 'react-icons/gr';
import { get_auth_key, getStoredData } from '../../../util';
import Kitchen from '../../../components/Kitchen';
import { Link } from 'react-router-dom';

const KitchenConsolidatedReport = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const [data, setData] = useState([]);
  const clickToDownload = useRef(null);
  const [state, setState] = useState({
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    kitchenId: '',
    dateFrom: '',
    dateTo: '',
  });
  const [factories, setFactories] = useState([]);
  const [kitchenQuery, setKitchenQuery] = useState(!admins ? `factoryId=${+storedData?.locationId[0]}` : '');

  const getConsolidatedReport = (download = false) => {
    if (state.factoryId) {
      let url = `/inv/report/kitchen-consolidated/?kitchenId=${state.kitchenId}&factoryId=${state.factoryId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}&download=${download}`;
      get(url)
        .then((res) => {
          if (download) {
            clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${res.data.filePath}`;
            setTimeout(() => {
              clickToDownload.current.click();
            }, 500);
          } else {
            setData(res?.data);
          }
        })
        .catch((err) => {
          toast.error(err?.response?.data.data.message || err?.message);
        });
    }
  };

  function getFactories() {
    get(`/branches/?type=factory`)
      .then((response) => {
        setFactories(response?.data?.rows);
      })
      .catch((err) => {
        toast.error(err?.response?.data.data.message || err?.message);
      });
  }

  useEffect(() => {
    getConsolidatedReport();
  }, []);

  useEffect(() => {
    getFactories();
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <div className="col-3">
            <div className="d-flex" style={{ height: '100%', alignItems: 'center' }}>
              <h4 className="card-title" style={{ fontSize: '16px' }}>
                Kitchen Consolidated Report
              </h4>
            </div>
          </div>
          <div className="card-header-actions col-9 d-flex justify-content-end">
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel label="Factory" className="mb-3">
                <Factory
                  factoryId={state.factoryId}
                  disabled={!admins}
                  onChange={(e) => {
                    setState({ ...state, factoryId: e.target.value });
                    setKitchenQuery(`factoryId=${+e.target.value}`);
                  }}
                  factories={factories}
                  label="factory"
                  name="factoryId"
                />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <div className="mb-3">
                <Kitchen
                  query={kitchenQuery}
                  kitchenId={state.kitchenId}
                  onChange={(kitchenId) => setState({ ...state, kitchenId })}
                  name={'kitchenId'}
                  isDisabled={state.factoryId === ''}
                />
              </div>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="From Date">
                <Form.Control value={state.dateFrom} onChange={(e) => setState({ ...state, dateFrom: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px' }}>
              <FloatingLabel className="mb-3" controlId="floatingInput" label="To Date">
                <Form.Control value={state.dateTo} onChange={(e) => setState({ ...state, dateTo: e.target.value })} type="date" />
              </FloatingLabel>
            </div>
            <div style={{ maxWidth: '200px', marginRight: '20px', alignItems: 'center' }}>
              <Button onClick={() => getConsolidatedReport()} type="submit" className="btn app-btn-default dark-color">
                Apply
              </Button>
            </div>
            <div style={{ alignItems: 'center' }}>
              <GrDocumentExcel
                title="Download Excel"
                className="react-icons green"
                style={{ width: '30px', height: '30px', cursor: 'pointer' }}
                onClick={() => getConsolidatedReport(true)}
              />
              <a ref={clickToDownload} href="/" target="_blank" className="hiddenItem">
                HiddenClick
              </a>
            </div>
          </div>
        </div>
        <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
          <div className="row">
            <div className="col">
              <Table responsive striped bordered>
                <thead>
                  <tr>
                    <th style={{ width: '5%' }}>#</th>
                    <th style={{ width: '10%' }}>Kitchen</th>
                    <th style={{ width: '25%' }}>Indent Numbers</th>
                    <th style={{ width: '35%' }}>Item</th>
                    <th style={{ width: '15%' }}>Quantity</th>
                    <th style={{ width: '10%' }}>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {data.map((item, index) => {
                    const rowSpan = item.items_details.length;
                    const item_details = item?.items_details;
                    return (
                      <>
                        <tr key={item?.id}>
                          <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                            {index + 1}
                          </td>
                          <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                            {item.kitchen_name}
                          </td>
                          <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                            {item?.productionIndentNumbers.join(', ')}
                          </td>
                          <td>{`${item_details[0]?.name} (${item_details[0]?.unit})`}</td>
                          <td>{item_details[0]?.quantity}</td>
                          <td rowSpan={rowSpan} style={{ verticalAlign: 'top' }}>
                            <Link
                              to={`/inv/kitchen-consolidated-report/print?kitchenId=${item.kitchenId}&factoryId=${item.factoryId}&dateFrom=${state.dateFrom}&dateTo=${state.dateTo}`}
                              target="_blank"
                              className="edit-icon"
                              style={{ color: '#3c8dbc' }}
                            >
                              Print
                            </Link>
                          </td>
                        </tr>
                        {item_details.map((detail, _index) => {
                          if (_index === 0) {
                            return null;
                          }
                          return (
                            <tr key={_index}>
                              <td style={{ padding: '.6rem .5rem' }}>{`${detail.name} (${detail.unit})`}</td>
                              <td style={{ padding: '.6rem .5rem' }}>{detail?.quantity}</td>
                            </tr>
                          );
                        })}
                      </>
                    );
                  })}
                </tbody>
              </Table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default KitchenConsolidatedReport;
